<template>
  <v-app id="inspire">
    <RouterView />
  </v-app>
</template>

<script setup>

</script>

<style>
#inspire{
  background-color: #FAFAFA;
}
#inspire .v-application__wrap{
  justify-content:center;
}
</style>
